import { createSelector } from 'reselect';

const selectTenantOpennetworkDomains = (state: any) => state.tenantOpenNetworkDomains;


export const selectTenantOpennetworkDomainsCurrentItem = createSelector([selectTenantOpennetworkDomains], (tenantOpenNetworkDomains) => tenantOpenNetworkDomains.current);

export const selectTenantOpennetworkDomainsListItems = createSelector([selectTenantOpennetworkDomains], (tenantOpenNetworkDomains) => tenantOpenNetworkDomains.list);

export const selectTenantOpennetworkDomainsItemById = (itemId: any) =>
    createSelector(selectTenantOpennetworkDomainsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectOpennetworkDomainCreatedItem = createSelector([selectTenantOpennetworkDomains], (tenantOpenNetworkDomains) => tenantOpenNetworkDomains.create);

export const selectOpennetworkDomainQueryItems = createSelector([selectTenantOpennetworkDomains], (tenantOpenNetworkDomains) => tenantOpenNetworkDomains.query);

export const selectOpennetworkDomainUpdatedItem = createSelector([selectTenantOpennetworkDomains], (tenantOpenNetworkDomains) => tenantOpenNetworkDomains.update);

export const selectOpennetworkDomainReadItem = createSelector([selectTenantOpennetworkDomains], (tenantOpenNetworkDomains) => tenantOpenNetworkDomains.read);

export const selectOpennetworkDomainDeletedItem = createSelector([selectTenantOpennetworkDomains], (tenantOpenNetworkDomains) => tenantOpenNetworkDomains.delete);

export const selectOpennetworkDomainSearchedItems = createSelector([selectTenantOpennetworkDomains], (tenantOpenNetworkDomains) => tenantOpenNetworkDomains.search);

export const selectOpennetworkDomainItemsCount = createSelector([selectTenantOpennetworkDomains], (tenantOpenNetworkDomains) => tenantOpenNetworkDomains.count);

export const selectOpennetworkDomainPublishedItem = createSelector([selectTenantOpennetworkDomains], (tenantOpenNetworkDomains) => tenantOpenNetworkDomains.publish);

export const selectOpennetworkDomainItemsFilter = createSelector([selectTenantOpennetworkDomains], (tenantOpenNetworkDomains) => tenantOpenNetworkDomains.filter);